export default __webpack_public_path__ + "static/media/everything.d1a5761e.svg";